var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orderNav" },
    [
      _c(
        "el-submenu",
        { attrs: { index: "1" } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { staticClass: "iconfont icon-dingdan" }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.ptitle))])
          ]),
          _vm._v(" "),
          _vm._l(_vm.menuList, function(item, i) {
            return _c(
              "el-menu-item",
              {
                key: i,
                attrs: { index: item.index },
                on: {
                  click: function($event) {
                    return _vm.rediret(item)
                  }
                }
              },
              [
                _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                  _vm._v(_vm._s(item.title))
                ])
              ]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3361b7cd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3361b7cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/leftnav/orderNav.vue
// module id = null
// module chunks = 